export default function authHeader(store) {
  const jwtString = store.getters.jwtToken;
  if (jwtString == null) {
    return {};
  }
  return { Authorization: "Bearer " + jwtString };
}
